import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageHeroSection.css';

function PageHeroSection({ title, subtitle, imageSrc, imageMobileSrc, imageAlt }) {
    return (
        <section className={styles.root}>
            <div className={styles.content}>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.subtitle}>{subtitle}</p>
            </div>
            {Boolean(imageSrc) && (
                <picture>
                    <source
                        srcSet={imageMobileSrc}
                        media='(max-width: 518px)'
                    />
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className={styles.image}
                    />
                </picture>
            )}
        </section>
    );
}

PageHeroSection.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    imageSrc: PropTypes.string,
    imageMobileSrc: PropTypes.string,
    imageAlt: PropTypes.string
};

PageHeroSection.defaultProps = {
    imageSrc: '',
    imageMobileSrc: '',
    imageAlt: ''
};

export {
    PageHeroSection
};
